import { render, staticRenderFns } from "./consignmentReconciliationAction copy.vue?vue&type=template&id=6e20ca04&scoped=true"
import script from "./consignmentReconciliationAction copy.vue?vue&type=script&lang=js"
export * from "./consignmentReconciliationAction copy.vue?vue&type=script&lang=js"
import style0 from "./consignmentReconciliationAction copy.vue?vue&type=style&index=0&id=6e20ca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20ca04",
  null
  
)

export default component.exports